<template>
	<div class="container_head ">
		<van-search v-model="value" shape="round" placeholder="请输入关键词" clearable @search="onSearch"  class="topsearch"/>
		<van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="list">
			<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
				<van-cell v-for="item in list" :key="item.title" :title="item.title" center :value="item.money" :label="item.date" value-class="money"/>
			</van-list>
		</van-pull-refresh>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Search,
		Toast
	} from 'vant';
	import {
		List
	} from 'vant';
	Vue.use(List);
	Vue.use(Search).use(Toast);
	import { mapState, mapMutations } from "vuex";
	export default {
		data() {
			return {
				value: '',
				list: [],
				loading: false,
				finished: false,
				refreshing: false,
				pageNum:0,
			};
		},
		computed: {
			...mapState(['userInfo','identity','houseId']),
		},
		mounted() {},
		methods: {
			onSearch(val) {
				Toast(val);
			},
			onRefresh() {
				this.finished = false;
				// 重新加载数据
				// 将 loading 设置为 true，表示处于加载状态
				this.loading = true;
				this.onLoad();
			},
			onLoad() {
				if (this.refreshing) {
					// 清空列表数据
					this.list = [];
					this.refreshing = false;
				}
				/* this.$axios.get('/api/v1/maintenance/house/'+this.houseId, {
					 params: {
						pageNum:this.pageNum,
						pageSize:15
					} 
				}).then(res => {
					this.list.push(...res.data);
					this.loading = false;
					if (this.list.length >= 0) {
						this.finished = true;
					}
				}); */
				for (let i = 0; i < 10; i++) {
					this.list.push({
						title:'小区路灯维修'+(this.list.length + 1),
						date:'2021-04-30 19:39',
						money:"271.00"
					});
				} 
				this.loading = false;
				if (this.list.length >= 20) {
					this.finished = true;
				}
			},
			changeview(path) {
				this.$router.push(path);
			}
		}
	};
</script>

<style lang="less" scoped>
	.flexcenter {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.topsearch{
		position: fixed;
		top: 46px;
		width: 100%;
		z-index: 999;
	}
	.list{
		margin-top: 55px;
	}
	.money{
		font-weight: bold;
		font-size: 18px;
		color: #333;
	}
</style>
